import {
  CAMPAIGN_MANAGER,
  CAMPAIGN_PLANNER,
  CAMPAIGN_STATUS_PLEA_REQUEST_FINAL_APPROVAL_ACCEPTED,
  CAMPAIGN_STATUS_PLEA_REQUEST_FINAL_APPROVAL_REJECTED,
  CAMPAIGN_STATUS_PLEA_REQUEST_FINAL_APPROVAL_SENT,
  CLIENT_POC_USER,
  SCREEN_OWNER,
} from "../constants/userConstants";
import {
  CAMPAIGN_PLAN_TYPE_KNOW,
  CAMPAIGN_PLAN_TYPE_REGULAR,
  CAMPAIGN_PLAN_TYPE_STORE,
  CAMPAIGN_PLAN_TYPE_TOPICAL,
  CAMPAIGN_PLAN_TYPE_TRIGGER,
  CAMPAIGN_STATUS_PLEA_REQUEST_BUDGET_ACCEPTED,
  CAMPAIGN_STATUS_PLEA_REQUEST_BUDGET_REJECTED,
  CAMPAIGN_STATUS_PLEA_REQUEST_BUDGET_SENT,
  CAMPAIGN_STATUS_PLEA_REQUEST_CLIENT_BUDGET_APPROVAL_ACCEPTED,
  CAMPAIGN_STATUS_PLEA_REQUEST_CLIENT_BUDGET_APPROVAL_REJECTED,
  CAMPAIGN_STATUS_PLEA_REQUEST_CLIENT_BUDGET_APPROVAL_SENT,
  CAMPAIGN_STATUS_PLEA_REQUEST_CREATIVE_APPROVAL_ACCEPTED,
  CAMPAIGN_STATUS_PLEA_REQUEST_CREATIVE_APPROVAL_REJECTED,
  CAMPAIGN_STATUS_PLEA_REQUEST_CREATIVE_APPROVAL_SENT,
  CAMPAIGN_STATUS_PLEA_REQUEST_SCREEN_APPROVAL_ACCEPTED,
  CAMPAIGN_STATUS_PLEA_REQUEST_SCREEN_APPROVAL_REJECTED,
  CAMPAIGN_STATUS_PLEA_REQUEST_SCREEN_APPROVAL_SENT,
  CAMPAIGN_STATUS_PLEA_REQUEST_VENDOR_BUDGET_APPROVAL_ACCEPTED,
  CAMPAIGN_STATUS_PLEA_REQUEST_VENDOR_BUDGET_APPROVAL_REJECTED,
  CAMPAIGN_STATUS_PLEA_REQUEST_VENDOR_BUDGET_APPROVAL_SENT,
} from "../constants/campaignConstants";

export const getCampaignPageNameFromCampaignType = (value) => {
  if (!value) return "";
  const campaignTypeMap = {
    [CAMPAIGN_PLAN_TYPE_REGULAR]: "regularplan",
    [CAMPAIGN_PLAN_TYPE_TRIGGER]: "triggerbasedplan",
    [CAMPAIGN_PLAN_TYPE_STORE]: "storebasedplan",
    [CAMPAIGN_PLAN_TYPE_TOPICAL]: "specialdayplan",
    [CAMPAIGN_PLAN_TYPE_KNOW]: "iknowitallplan",
  };

  return campaignTypeMap[value] || "";
};

export const getUserRole = (value) => {
  if (!value) return "";

  const userRole = {
    [CAMPAIGN_PLANNER]: "planner",
    [CAMPAIGN_MANAGER]: "planner",
    [CLIENT_POC_USER]: "client",
    [SCREEN_OWNER]: "vendor",
  };

  return userRole[value] || "client";
};

export const getRequestNameFromStatus = (status) => {
  const statusMap = {
    [CAMPAIGN_STATUS_PLEA_REQUEST_BUDGET_SENT]: "Budget Request Sent",
    [CAMPAIGN_STATUS_PLEA_REQUEST_BUDGET_ACCEPTED]: "Draft",
    [CAMPAIGN_STATUS_PLEA_REQUEST_BUDGET_REJECTED]: "Budget Rejected",
    [CAMPAIGN_STATUS_PLEA_REQUEST_SCREEN_APPROVAL_SENT]:
      "Screen Approval Request",
    [CAMPAIGN_STATUS_PLEA_REQUEST_SCREEN_APPROVAL_ACCEPTED]: "Screen Approved",
    [CAMPAIGN_STATUS_PLEA_REQUEST_SCREEN_APPROVAL_REJECTED]: "Screen Rejected",
    [CAMPAIGN_STATUS_PLEA_REQUEST_CLIENT_BUDGET_APPROVAL_SENT]:
      "Client Budget Approval Request Sent",
    [CAMPAIGN_STATUS_PLEA_REQUEST_CLIENT_BUDGET_APPROVAL_ACCEPTED]:
      "Client Budget Approved",
    [CAMPAIGN_STATUS_PLEA_REQUEST_CLIENT_BUDGET_APPROVAL_REJECTED]:
      "Client Budget Rejected",
    [CAMPAIGN_STATUS_PLEA_REQUEST_VENDOR_BUDGET_APPROVAL_SENT]:
      "Vendor Budget Approval Request Sent",
    [CAMPAIGN_STATUS_PLEA_REQUEST_VENDOR_BUDGET_APPROVAL_ACCEPTED]:
      "Vendor Budget Approved",
    [CAMPAIGN_STATUS_PLEA_REQUEST_VENDOR_BUDGET_APPROVAL_REJECTED]:
      "Vendor Budget Rejected",
    [CAMPAIGN_STATUS_PLEA_REQUEST_CREATIVE_APPROVAL_SENT]:
      "Creative Approval Request Sent",
    [CAMPAIGN_STATUS_PLEA_REQUEST_CREATIVE_APPROVAL_ACCEPTED]:
      "Creative Approved",
    [CAMPAIGN_STATUS_PLEA_REQUEST_CREATIVE_APPROVAL_REJECTED]:
      "Creative Rejected",
    [CAMPAIGN_STATUS_PLEA_REQUEST_FINAL_APPROVAL_SENT]:
      "Final Approval Request Sent",
    [CAMPAIGN_STATUS_PLEA_REQUEST_FINAL_APPROVAL_ACCEPTED]: "Final Approved",
    [CAMPAIGN_STATUS_PLEA_REQUEST_FINAL_APPROVAL_REJECTED]: "Final Rejected",
  };

  return statusMap[status] || "Unknown Request";
};

export const getColorCodeOnBasicOfStatus = (status) => {
  return status.includes("Approved")
    ? `text-[#16a34a]`
    : status.includes("Rejected")
    ? `text-[#dc2626]`
    : `text-[#ca8a04]`;
};
